import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { Typography } from "@material-ui/core";

import { COLORS } from "../../../../../theme/colors";
import { NO_DATA_TEXT } from "../../../../../constants";
import { getData, nFormatter } from "../../../../../services";
import { ShaDowBox } from "../../../../../components/boxes";
import { TenancyData } from "../../../../../components/parts";
import { iconSrc } from "../../../../../components/parts/connectionStatus";
import { getLabel } from "../../../../../services";

const defaultResults = (unitSystem) => [
  {
    title: "Tenant",
    value: NO_DATA_TEXT,
  },
  {
    title: "Units rented",
    value: NO_DATA_TEXT,
  },
  {
    title: "Total Rental Area",
    value: nFormatter(0),
    unit: unitSystem,
  },
  {
    title: "Tenancy Connection Status",
    value: NO_DATA_TEXT,
  },
  {
    title: "Missing Connection Docs",
    value: 0,
  },
];

export const TenantTenancyDataInfo = ({ tId }) => {
  const { id } = useParams();
  const { user } = useSelector((state) => state.auth);
  const [results, setResults] = useState(defaultResults(user.unit_system));

  useEffect(() => {
    getData(`/praas/v2/buildings/${id}/tenants/${tId}/`, (tenant) => {
      setResults([
        {
          title: "Tenant",
          value: tenant.name,
        },
        {
          title: "Units rented",
          value:
            tenant.rented_units?.length > 1 ? (
              <Typography>
                <Typography component="span" variant="h3">
                  {tenant.rented_units[0].unit_id}
                </Typography>{" "}
                + {tenant.rented_units.length - 1} more...
              </Typography>
            ) : tenant.rented_units?.length === 1 ? (
              tenant.rented_units[0].unit_id
            ) : null,
        },
        {
          title: "Total Rental Area",
          value: nFormatter(tenant.rented_area),
          unit: user.unit_system,
        },
        {
          title: "Tenancy Connection Status",
          image_src: iconSrc[tenant?.status],
          value: getLabel(tenant?.status),
        },
        {
          title: "Missing Connection Docs",
          value: tenant.missing_docs,
          color: COLORS.red,
        },
      ]);
    });

    return () => setResults([]);
  }, []);

  return (
    <ShaDowBox>
      <TenancyData results={results} />
    </ShaDowBox>
  );
};
